import axios from 'axios'
import qs from 'qs'
// wang: e5653bf3f17044ec910fb539ee5f6b9a
// 9kacha: 122245c81b0047419179f2d7eacbfbb8
const APPCODE = 'e5653bf3f17044ec910fb539ee5f6b9a'

const requestHeader = {
  method: 'POST',
  headers: {
    'content-type': 'application/json; charset=UTF-8',
    'Authorization': `APPCODE ${APPCODE}`
  }
}

export default function (imgBase64) {
  // 测试上传图片
  // _localTestUploadImage(imgBase64)

  return new Promise((resolve, reject) => {
    axios({
      url: `https://dm-57.data.aliyun.com/rest/160601/ocr/ocr_business_card.json`,
      ...requestHeader,
      data: { image: imgBase64 }
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        console.log('网络错误', err)
        reject(err)
      })
  })
}

function _localTestUploadImage (imgBase64) {
  if (process.env.NODE_ENV === 'development') {
    axios({
      url: 'http://192.168.8.55:5002/uploadImage',
      method: 'POST',
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      data: qs.stringify({ image: imgBase64 })
    })
      .then(res => {
        console.log('测试成功', res.data)
      })
      .catch(err => {
        console.log('测试失败', err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/ocrBusinessCard.js